import Model from '@/store/plugins/orm/Model';
import { Product } from './ModelRepository';

export class ReceptionItem extends Model {
    static get entity () {
        return 'reception_items'
    }

    static fields () {
        return {
            id: this.attr(null),
            reception_id: this.attr(null),
            product_id: this.attr(null),
            count: this.attr('0.000', value => _.round(value, 3).toFixed(3)),

            product: this.attr(null, value => !!value ? new Product(value) : null),
        }
    }

    getCount() {
        return parseFloat(this.count);
    }

    getProduct() {
        if(this.product) return this.product;
        return Product.all().find(product => product.id === this.product_id);
    }
}

export default ReceptionItem
